const state = {
  isRestTime: false
}

const getters = {
}

const mutations = {
  setBreak (state, status) {
    state.isRestTime = status
  }
}

const actions = {
  setBreak ({ commit }, payload) {
    commit('setBreak', payload.status)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
